import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOpMessageList, sendOpMessage } from '@/api/apis';
export default {
  name: 'MessageManager',
  data: function data() {
    return {
      loading: false,
      sendLoading: false,
      list: [],
      total: 0,
      sendVisible: false,
      isEdit: false,
      // 标识当前是否为编辑模式
      queryParams: {
        page: 1,
        limit: 20,
        where: {
          biz_type: 'system',
          status: 1
        }
      },
      sendForm: {
        id: undefined,
        // 编辑时需要的ID
        title: '',
        biz_type: 'system',
        content: '',
        link_type: 'url',
        link_value: '',
        status: 1,
        level: 0,
        scope: 2,
        numbers: ''
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    formatTimestamp: function formatTimestamp(timestamp) {
      if (!timestamp || timestamp === 0) return '-';
      var date = new Date(String(timestamp).length === 10 ? timestamp * 1000 : timestamp);
      var y = date.getFullYear();
      var m = (date.getMonth() + 1).toString().padStart(2, '0');
      var d = date.getDate().toString().padStart(2, '0');
      var h = date.getHours().toString().padStart(2, '0');
      var i = date.getMinutes().toString().padStart(2, '0');
      var s = date.getSeconds().toString().padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(d, " ").concat(h, ":").concat(i, ":").concat(s);
    },
    getList: function getList() {
      var res;
      return regeneratorRuntime.async(function getList$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              _context.next = 4;
              return regeneratorRuntime.awrap(getOpMessageList(this.queryParams));

            case 4:
              res = _context.sent;

              if (res) {
                this.list = res.rows || [];
                this.total = res.count || 0;
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              this.$message.error('获取列表失败');

            case 11:
              _context.prev = 11;
              this.loading = false;
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[1, 8, 11, 14]]);
    },

    /**
     * 处理 Excel 导入
     */
    handleExcelImport: function handleExcelImport(file) {
      var _this = this;

      // 1. 调用你现有的全局导入插件
      this.$import.xlsx(file.raw).then(function (_ref) {
        var header = _ref.header,
            results = _ref.results;
        // 调试：查看解析出来的表头和内容
        console.log('表头:', header);
        console.log('内容:', results);

        if (!results || results.length === 0) {
          _this.$message.error('Excel 内容为空');

          return;
        } // 2. 寻找匹配 "number" 标题的列名
        // 你的插件返回的 results 通常是对象数组，Key 就是表头文字


        var targetKey = header.find(function (h) {
          return h && h.toString().trim().toLowerCase() === 'number';
        });

        if (!targetKey) {
          _this.$message.error('未在 Excel 首行找到 "number" 列');

          return;
        } // 3. 提取数据


        var importedNumbers = results.map(function (item) {
          return item[targetKey];
        }).filter(function (val) {
          return val !== undefined && val !== null && val !== '';
        }).map(function (val) {
          return val.toString().trim();
        });

        if (importedNumbers.length > 0) {
          // 4. 合并现有数据并去重
          var currentNumbers = _this.sendForm.numbers ? _this.sendForm.numbers.split(',').map(function (s) {
            return s.trim();
          }) : [];
          var combined = Array.from(new Set([].concat(_toConsumableArray(currentNumbers), _toConsumableArray(importedNumbers)))).filter(function (s) {
            return s;
          }); // 5. 赋值回表单（建议使用 $set 确保 textarea 实时显示）

          _this.$set(_this.sendForm, 'numbers', combined.join(','));

          _this.$message.success("\u6210\u529F\u4ECE \"".concat(targetKey, "\" \u5217\u5BFC\u5165 ").concat(importedNumbers.length, " \u6761\u6570\u636E"));
        } else {
          _this.$message.warning('该列下未发现有效编号');
        }
      }).catch(function (err) {
        console.error('导入失败:', err);

        _this.$message.error('文件解析失败，请检查文件格式');
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams.where = {
        biz_type: '',
        status: null
      };
      this.handleQuery();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    handleView: function handleView(row) {
      this.$alert(row.content || '暂无详细内容', row.title || '消息详情');
    },
    // 打开新增窗口
    handleOpenSend: function handleOpenSend() {
      this.isEdit = false;
      this.resetSendForm();
      this.sendVisible = true;
    },
    // 打开编辑窗口
    handleEdit: function handleEdit(row) {
      var _this2 = this;

      this.isEdit = true;
      this.sendVisible = true; // 将行数据拷贝到表单中，注意确保字段匹配

      this.$nextTick(function () {
        _this2.sendForm = {
          id: row.id,
          title: row.title,
          biz_type: row.biz_type,
          status: row.status,
          content: row.content,
          link_type: row.link_type || 'url',
          link_value: row.link_value,
          level: row.level || 0,
          scope: row.scope || 2,
          numbers: row.numbers || ''
        };
      });
    },
    resetSendForm: function resetSendForm() {
      this.sendForm = {
        id: undefined,
        title: '',
        biz_type: 'system',
        content: '',
        link_type: 'url',
        status: 1,
        link_value: '',
        level: 0,
        scope: 2,
        numbers: ''
      };
    },
    submitSend: function submitSend() {
      return regeneratorRuntime.async(function submitSend$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this.sendForm.title) {
                _context2.next = 3;
                break;
              }

              this.$message.warning('请输入消息标题');
              return _context2.abrupt("return");

            case 3:
              if (this.sendForm.content) {
                _context2.next = 6;
                break;
              }

              this.$message.warning('请输入消息内容');
              return _context2.abrupt("return");

            case 6:
              if (!(this.sendForm.scope === 1 && !this.sendForm.numbers)) {
                _context2.next = 9;
                break;
              }

              this.$message.warning('定向发送请填写用户编号');
              return _context2.abrupt("return");

            case 9:
              this.sendLoading = true;
              _context2.prev = 10;
              _context2.next = 13;
              return regeneratorRuntime.awrap(sendOpMessage(this.sendForm));

            case 13:
              this.$message.success(this.isEdit ? '修改成功' : '发送成功');
              this.sendVisible = false;
              this.getList();
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](10);
              console.error(_context2.t0);

            case 21:
              _context2.prev = 21;
              this.sendLoading = false;
              return _context2.finish(21);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this, [[10, 18, 21, 24]]);
    }
  }
};